import React from "react";
import { Grid } from "@mui/material";
import FrameQualityOverview from "./FrameQualityOverview";
import FrameTypeDistributionChart from "./FrameTypeDistributionChart";
import AverageFocusQualityCard from "./AverageFocusQualityCard";
import GuidingAccuracyCard from "./GuidingAccuracyCard";
import { ImageMetadata } from "../types";

interface OverviewTabPanelProps {
  imagesForView: ImageMetadata[];
}

const OverviewTabPanel: React.FC<OverviewTabPanelProps> = ({
  imagesForView,
}) => (
  <Grid container spacing={3}>
    {/* Frame Quality Overview (HFR line chart) */}
    <Grid size={{ xs: 12, md: 8 }}>
      <FrameQualityOverview imagesForView={imagesForView} />
    </Grid>
    {/* Frame Type Distribution (donut chart) */}
    <Grid size={{ xs: 12, md: 4 }}>
      <FrameTypeDistributionChart imagesForView={imagesForView} />
    </Grid>
    {/* Second row: Average Focus Quality and Guiding Accuracy */}
    <Grid container spacing={3} size={{ xs: 12 }}>
      {/* Average Focus Quality */}
      <Grid size={{ xs: 12, md: 6 }}>
        <AverageFocusQualityCard imagesForView={imagesForView} />
      </Grid>
      {/* Guiding Accuracy */}
      <Grid size={{ xs: 12, md: 6 }}>
        <GuidingAccuracyCard imagesForView={imagesForView} />
      </Grid>
    </Grid>
  </Grid>
);

export default OverviewTabPanel;
